import { Box, Modal } from "@mui/material";
import { useEffect } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import StaticIPDisplay from "../../../../components/StaticIPDisplay";

const BreezeStaticIPsModal = ({ open, onClose }) => {
  const colors = useColors();
  const { trackEvent } = useAPI();

  useEffect(() => {
    if (open) {
      trackEvent("User clicked to open Breeze Static IPs modal");
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "600px",
          maxHeight: "80vh",
          borderRadius: "10px",
          padding: "32px",
          outline: "none",
          boxShadow: "0px 1px 4px 0px " + colors.grey_24percent,
          backgroundColor: colors.common_white,
          overflow: "auto",
        }}
      >
        <Box display="flex" flexDirection="column" gap={3}>
          <StaticIPDisplay containerWidth="100%" />
        </Box>
      </Box>
    </Modal>
  );
};

export default BreezeStaticIPsModal;
